import * as React from "react"
import {
  PermissionsResource,
  PermissionsCheck,
  PermissionsCheckProps,
} from "@modules/permissions"
import { useOrganizationPermissionsFieldsFragment } from "@modules/organization/fragments.generated"

export type OrganizationPermissionsProps<T extends PermissionsResource> = Omit<
  PermissionsCheckProps<T>,
  "digest"
> & {
  id: string
}

export function OrganizationPermissions<T extends PermissionsResource>({
  id,
  ...rest
}: OrganizationPermissionsProps<T>) {
  const { data } = useOrganizationPermissionsFieldsFragment(id)

  return <PermissionsCheck digest={data?.permissions ?? null} {...rest} />
}
